export default defineNuxtRouteMiddleware((to) => {
  const page = Array.isArray(to.params.page) ? to.params.page[0] : to.params.page
  if (page !== '1') return

  // Preserve the locale prefix, category path, and search query while removing the duplicate first-page segment.
  return navigateTo(
    {
      path: to.path.replace(/\/page\/1\/search$/, '/search'),
      query: to.query,
    },
    { redirectCode: 301 },
  )
})
